module.exports = __webpack_public_path__ + "static/media/close-red-big.6a5f0d97.svg";